import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import config from '../config';

const { desktopMinWidth } = config

// Props
// 0) style (object)
// 1) header (string)
// 2) placeholder (string)
// 3) pre (boolean)

class TextForm extends React.Component {
  Wrapper = ({ children }) => (
    <this.Container style={this.props.style}>
      {/* Text form 제목 */}
      <this.Header>
        {this.props.header === undefined ? "undefined" : this.props.header}
      </this.Header>
      {children}
    </this.Container>
  )

  render() {
    const { Wrapper } = this;
    const { style, header, placeholder, type, ...rest } = this.props;
    return (
      <Wrapper>
        {
          this.props.pre === true
            ? <this.Pre> {this.props.placeholder} </this.Pre>
            : <this.Input placeholder={this.props.placeholder} {...rest} />
        }
      </Wrapper>
    )
  }
  /* Style components */
  Container = styled.div`
    text-align: left;
    overflow: hidden;
  `;
  Header = styled.div`
    font-family: var(--font);
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0 0.87);
    line-height: 1;
  `;
  Input = styled.input`
    box-sizing: border-box;
    font-family: var(--font);
    font-weight: 300;
    font-size: 14px;
  
    color: rgba(0, 0, 0, 0.38);
    background-color: rgba(0, 0, 0, 0.06);
    border: none;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 4px;

    width: 100%;
    height: auto;
    margin-top: 20px;
    overflow-x: scroll;

    outline: none;

    /* PC 화면 */
    @media only screen and (min-width: ${desktopMinWidth}) {
      font-size: 16px;
    }
  `;
  Pre = styled.pre`
    box-sizing: border-box;
    font-family: var(--font);
    font-weight: 300;
    font-size: 14px;
  
    color: rgba(0, 0, 0, 0.38);
    background-color: rgba(0, 0, 0, 0.06);
    border: none;
    padding: 8px;
    border-radius: 4px;

    width: 100%;
    height: auto;
    margin-top: 20px;
    overflow-x: scroll;

    outline: none;

    line-height: 1.5;
    
    /* PC 화면 */
    @media only screen and (min-width: ${desktopMinWidth}) {
      font-size: 16px;
    }
  `;
}

TextForm.propTypes = {
  style: PropTypes.object,
  header: PropTypes.string,
  placeholder: PropTypes.string,
  pre: PropTypes.bool
}

export default TextForm;